import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'common-preview-image',
  templateUrl: './preview-image.component.html',
  styleUrls: ['./preview-image.component.scss']
})
export class PreviewImageComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<PreviewImageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { image: string, width?: number, height?: number },
  ) {
    this.data.width = this.data.width || 600;
    this.data.height = this.data.height || 406;
  }

  ngOnInit(): void {
  }

}
